<template>
  <div class="flex px-[15px] gap-[6px]">
    <div @click="handleNewDialog" :class="[
      ' py-[10px] flex-1 items-center cursor-pointer h-[40px] hover:shadow-lg duration-300 rounded-[4px]  box-border text-white text-[14px] new-item flex justify-center gap-[10px]',
      {
        'cursor-not-allowed': layoutStore.newDialogLoadingRef
      }
    ]">
      <div class="flex items-center gap-[4px]" v-if="!layoutStore.newDialogLoadingRef">
        <span class="leading-normal">+</span>
        <span v-if="!isSearch">新建任务</span>
      </div>
      <div v-else :class="['flex items-center gap-[4px]']">
        <el-icon size="14" color="#fff" class="rotate"><i-ep-loading /></el-icon>
        创建中...
      </div>
    </div>
    <div @click="searchTask" :class="[
      'flex gap-[11px] items-center px-[10px] w-[40px] rounded-[4px] search-wrap duration-150 justify-center cursor-pointer',
      {
        'search-180 bg-[#6a50fd]': isSearch
      }
    ]">
      <el-icon color="#fff"><i-ep-search /></el-icon>

      <div class="search-wrap" v-if="isSearch">
        <el-input v-model="taskStore.searchKey" size="default" placeholder="搜索对话" clearable />
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref } from 'vue'
import { useTaskStore } from '@/store/taskStore'
import { useLayoutStore } from '@/store/layoutStore'
import { newTask } from '@/service/task'
const isSearch = ref(false)
const taskStore = useTaskStore()
const layoutStore = useLayoutStore()
const searchTask = () => {
  isSearch.value = true
}
const handleNewDialog = () => {
  if (isSearch.value) {
    isSearch.value = false
    return
  }
  if (layoutStore.newDialogLoadingRef) return
  layoutStore.setDialogLoadingRef(true) // 打开侧边栏的loading
  taskStore.setCurrentTaskDetail({}) // 设置当前任务详情为空

  layoutStore.setShowResults(false) // 关闭结果页面

  try {
    layoutStore.setNewDialogLoadingRef(true) // 设置新建任务的loading
    layoutStore.setShowResults(false)
    newTask().then((res) => {
      layoutStore.newDialogLoadingRef = false
      const newTask = { ...taskStore.defaultTask, id: res.data.id }
      taskStore.updateTaskList([newTask])
      taskStore.setCurrentTaskDetail(newTask) // 设置当前任务详情
      layoutStore.toggleSidebar(true) // 打开侧边栏

      taskStore.initializeTaskDetail(newTask.id) // 初始化任务详情
    })
  } catch (error) {
    console.log(error)
  }
}
</script>
<style lang="scss" scoped>
.new-item {
  background: #2500f6b3;
  overflow: hidden;
  white-space: nowrap;
}

.search-wrap {
  background: #2500f6b3;
}

.search-180 {
  width: 180px !important;
}

.w-fit-content {
  width: fit-content;
  padding: 0 10px;
}

.taskList-search-wrap {
  width: 200px;
}

.rotate {
  animation: rotate 1s linear infinite;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
